<template>
    <page :loading="loading">
        <div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item label="关键字">
						<el-input v-model="table.search.keyword" placeholder="请输入账号/姓名/手机号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="账号状态">
						<el-select clearable v-model="table.search.status" placeholder="请选择">
						    <el-option :value="1" label="正常"></el-option>
						    <el-option :value="0" label="禁用"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" plain @click="LoadDatas(1,20)">搜索</el-button>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="info"    plain @click="reset">重置</el-button>
					</el-form-item>
				</el-form>
				<el-form size="small" :inline="true">
					<el-form-item>
						<el-button @click="table.form = {status: 1},showDialog = true" type="primary" plain>添加管理员</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

        <page-table :datas="table.data" :page="table.search._page" :size="table.search._size" :total="table._count" @change="LoadDatas">
            <el-table-column prop="id"            				   label="ID" align="center" fixed="left"  width="60"/>
			<el-table-column prop='name'                           label='管理员姓名' align='center'/>
			<el-table-column prop='role.name'                      label='身份' align='center'/>
			<el-table-column prop='username'                       label='账号' align='center'/>
			<el-table-column prop='phone'                          label='手机号' align='center'/>
			<el-table-column prop='status'                         label='是否禁用' align='center'>
			    <template slot-scope="scope">
			    	<el-tag v-if="scope.row.status">正常</el-tag>
			    	<el-tag v-else type="danger">禁用</el-tag>
			    </template>
			</el-table-column>
			<el-table-column prop='last_ip'                    	   label='最后登录IP' align='center'/>
			<el-table-column prop='created_at'                      label='创建时间' align='center'/>
            <el-table-column label="操作" align="center" fixed="right" width="200">
                <template slot-scope="scope">
					<el-button @click="table.form = scope.row, showDialog = true" type="text" size="small" :disabled="scope.row.level ? true : false">编辑</el-button>
					<el-button @click="table.form = {id: scope.row.id}, passwordDialog = true" type="text" size="small" :disabled="scope.row.level ? true : false">修改密码</el-button>
					<el-button @click="ActionDel(scope.row)" type="text" size="small" :disabled="scope.row.level ? true : false">删除</el-button>
                </template>
            </el-table-column>
        </page-table>
		
		<el-dialog :modal="false" title="管理员" :visible.sync="showDialog" width="35%">
			<el-form label-width="100px">
				<el-form-item label="管理员账号">
					<el-input v-model="table.form.username" placeholder="请输入管理员账号"></el-input>
				</el-form-item>
				<el-form-item label="管理员密码" v-if="!table.form.id">
					<el-input v-model="table.form.password" placeholder="请输入管理员密码"></el-input>
				</el-form-item>
				<el-form-item label="管理员姓名">
					<el-input v-model="table.form.name" placeholder="请输入管理员姓名"></el-input>
				</el-form-item>
				<el-form-item label="管理员身份">
					<el-select clearable v-model="table.form.role_id" placeholder="请选择">
					    <el-option v-for="(item, index) in roleList" :key="index" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="table.form.phone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-switch v-model="table.form.status" :active-value="1" :inactive-value="0" active-color="#188fff" inactive-color="#e5e5e5"></el-switch>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="ActionSave(table.form)">保存</el-button>
					<el-button @click="showDialog = false,table.form = {}">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<el-dialog title="修改密码" :visible.sync="passwordDialog" width="35%">
			<el-form label-width="100px">
				<el-form-item label="新密码">
					<el-input v-model="table.form.password" 		show-password placeholder="请输入新密码"></el-input>
				</el-form-item>
				<el-form-item label="确认密码">
					<el-input v-model="table.form.confirm_password" show-password placeholder="请输入确认密码"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="passwordSave(table.form)">保存</el-button>
					<el-button @click="passwordDialog = false,table.form = {}">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
    </page>
</template>
<script>
export default {
    data(){
        return {
			showDialog: false,
			passwordDialog: false,
            loading: false,
            table:{
                data: [],
                form: {},
                search: {
                    _page: 1,
                    _size: 20,
                },
				_count:0,
            },
			roleList: [],
        }
    },
    mounted() {
		this.LoadDatas();
		this.getRoleList();
    },
    methods: {
		passwordSave(passwordForm){
			if( !passwordForm.password ){
				return this.$warning('请输入新密码');
			}
			if( !passwordForm.confirm_password ){
				return this.$warning('请输入确认密码');
			}
			if( passwordForm.password != passwordForm.confirm_password ){
				return this.$warning('确认密码不一致');
			}
			this.$load();
			this.$save('sys-admin',passwordForm).then(res=>{
				this.passwordDialog = false;
				this.$load(false);
				this.$success('修改成功');
			}).catch(err=>{
				this.$load(false);
				this.$warning(err);
			})
		},
		getRoleList(){
			this.$get('sys-role', {_page: 1, _size: 1000}).then(res=>{   
			    this.roleList = res.data;
			}).catch(err=>{
			    this.$warning(err),this.loading = false;
			});
		},
		reset(){
			this.table.search = {
				_page:1,
				_size:20,
			};
			this.LoadDatas();
		},
        /**
         * 获取数据列表
         * @param page 分页-当前页
         * @param limit 分页-每页数量
         * **/
        LoadDatas(page,limit){
            page && (this.table.search._page = page),limit && (this.table.search._size = limit),this.loading = true;
            this.$get('sys-admin',this.table.search).then(res=>
            {   
                this.table.data = res.data, this.table.search._count = res.extra.pageInfo.count, this.loading = false;
            }).catch(err=>
            {
                this.$warning(err),this.loading = false;
            });
        },
        /**
         * 保存
         * @param item 要保存的数据
         * **/
        ActionSave(item){
        	if( !item.username ){
        		return this.$warning('请输入管理员账号');
        	}
        	if( !item.id && !item.password ){
        		return this.$warning('请输入管理员密码');
        	}
        	if( !item.name ){
        		return this.$warning('请输入管理员姓名');
        	}
			if( !item.role_id ){
				return this.$warning('请选择管理员身份');
			}
			if( !item.phone ){
				return this.$warning('请输入手机号');
			}
        	
            this.loading = true;
            this.$save('sys-admin',item).then(res=>
            {
                this.loading = false, this.LoadDatas(), this.$success('操作成功'), this.showDialog = false;
            }).catch(err=>
            {
                this.loading = false, this.$warning(err);
            });
        },
        /**
         * 删除
         * @param item 要删除的数据
         * **/
        ActionDel(item){
            if( item.id ){
                this.loading = true;
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                    this.$del('sys-admin/'+item.id).then(res=>{
                        this.loading = false, this.LoadDatas(), this.$warning(res.msg);
                    }).catch(err=>{
                        this.loading = false, this.$warning(err);
                    })
                }).catch(()=>{
                    this.loading = false;
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
	.page_header {
		margin:10px 10px 0;
		position: absolute;
		z-index: 100;
	}
</style>